import { useEffect, useState } from "react";
import { ArrowUpRight, Clock, Phone } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FALLBACK_HOURS = ["Monday – Friday: 7am – 5pm", "Saturday – Sunday: Closed"];

export default function Footer() {
  const [hours, setHours] = useState(null);

  useEffect(() => {
    fetch(`${API}/business`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d && Array.isArray(d.hours) && d.hours.length) setHours(d.hours);
      })
      .catch(() => {});
  }, []);

  return (
    <footer id="contact" data-testid="footer" className="relative overflow-hidden border-t border-white/10">
      <div className="tartan-bg absolute inset-0 opacity-[0.08]" />
      <div className="absolute inset-0 bg-[radial-gradient(900px_400px_at_50%_120%,rgba(240,168,41,0.14),transparent_65%)]" />

      <div className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
        <Reveal>
          <p className="font-mono-brand text-xs uppercase tracking-[0.35em] text-[#F0A829]">
            Ready when you are
          </p>
          <h2 className="font-display mt-5 text-5xl font-extrabold uppercase leading-[0.92] tracking-tight sm:text-7xl lg:text-8xl">
            <span className="text-[#F6F1E3]">Get it up the</span>
            <br />
            <span className="text-outline-gold">mountain today.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              data-testid="footer-call-button"
              href="tel:+61408464106"
              className="group flex items-center gap-3 rounded-full bg-[#F0A829] px-8 py-4 font-display text-lg font-bold uppercase tracking-wider text-[#0C1F17] transition-transform duration-300 hover:-translate-y-1"
            >
              <Phone className="h-5 w-5 transition-transform duration-300 group-hover:rotate-12" strokeWidth={2.5} />
              0408 464 106
            </a>
            <a
              data-testid="footer-website-link"
              href="https://www.kiltedcouriers.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-2 rounded-full border border-[#F6F1E3]/25 px-8 py-4 font-display text-lg font-bold uppercase tracking-wider text-[#F6F1E3] transition-colors duration-300 hover:border-[#F0A829] hover:text-[#F0A829]"
            >
              kiltedcouriers.com
              <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" strokeWidth={2.5} />
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div data-testid="footer-hours" className="mt-8 flex items-start gap-3">
            <Clock className="mt-1 h-4 w-4 shrink-0 text-[#F0A829]" />
            <div>
              <p className="font-mono-brand text-[10px] uppercase tracking-[0.3em] text-[#F0A829]">
                Trading hours
              </p>
              <div className="mt-2 flex flex-col gap-1">
                {(hours || FALLBACK_HOURS).map((h) => (
                  <p key={h} className="font-mono-brand text-[11px] uppercase tracking-[0.15em] text-[#B9C4B4]">
                    {h}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </Reveal>

        <div className="mt-24 flex flex-col items-start justify-between gap-10 border-t border-white/10 pt-10 md:flex-row md:items-end">
          <div className="flex items-center gap-5">
            <img
              src="/assets/logo.png"
              alt="The Kilted Courier logo"
              className="h-20 w-20 rounded-2xl bg-[#F6F1E3] object-contain p-1.5 ring-1 ring-[#F0A829]/50"
              data-testid="footer-logo"
            />
            <div>
              <p className="font-display text-2xl font-bold uppercase tracking-wide text-[#F6F1E3]">
                The Kilted Courier
              </p>
              <p className="font-mono-brand mt-1 text-[10px] uppercase tracking-[0.3em] text-[#B9C4B4]">
                Click &amp; collect — Canberra to the Snowies
              </p>
            </div>
          </div>
          <p className="font-mono-brand text-[10px] uppercase tracking-[0.25em] text-[#B9C4B4]">
            © {new Date().getFullYear()} The Kilted Courier · Same-day or next-day, kilt included
          </p>
        </div>
      </div>

      <div className="tartan-strip relative h-3 w-full opacity-80" />
    </footer>
  );
}
